import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import SuiVue from "semantic-ui-vue";
import VuePlayerPlugin from "vue-youtube-iframe-api";
import VueI18n from "vue-i18n";
import vueDebounce from "vue-debounce";
import Paginate from "vuejs-paginate";
import VueScrollTo from "vue-scrollto";
import Sticky from "vue-sticky-directive";
import VueAnalytics from "vue-analytics";

import App from "./App.vue";
import router from "./router";
import store from "./store";

// Translates
import { ptBR } from "./assets/translations/pt_BR.translation";
import { EN } from "./assets/translations/en.translation";
import { ES } from "./assets/translations/es.translation";

import "./services/works";
import "./services/about";
import "./services/offices";
import "./services/news";
import "./services/search";
import "./services/contact";
import "./services/home";
import "./services/names";

// Components
import HomeSlider from "./components/home/slider";
import Header from "./components/header";
import Search from "./components/search";
import Filter from "./components/filter";
import GridPostsHome from "./components/home/grid-posts";
import GridItem from "./components/home/grid-item";
import Footer from "./components/footer";
import MenuMobile from "./components/header/menu-mobile";
import GridWorks from "./components/grid-works";
import FullVideo from "./components/frames/full-video";
import ScrollTo from "./components/scrolltop";

Vue.use(Sticky);
Vue.use(VuePlayerPlugin);
Vue.use(VueI18n);
Vue.use(SuiVue);
Vue.use(VueAxios, axios);
Vue.use(vueDebounce);
Vue.component("paginate", Paginate);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: "UA-223929178-1",
  router,
});

// Register Components
Vue.component("main-header", Header);
Vue.component("home-slider", HomeSlider);
Vue.component("search", Search);
Vue.component("filter-country", Filter);
Vue.component("grid-posts-home", GridPostsHome);
Vue.component("grid-item", GridItem);
Vue.component("main-footer", Footer);
Vue.component("menu-mobile", MenuMobile);
Vue.component("grid-works", GridWorks);
Vue.component("frame-full-video", FullVideo);
Vue.component("scroll-to", ScrollTo);

// Instance to broadcast events;
Vue.prototype.$hub = new Vue();

const i18n = new VueI18n({ messages: { ...ptBR, ...EN, ...ES }, silentTranslationWarn: true });

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
